<template>
  <v-text-field
    ref="field"
    :prefix="prefix"
    v-model="model"
    @focus="onFocus"
    @keyup="onKeyUp"
    :error-messages="errorMessages"
    v-bind="$attrs"
    :rules="rules"
    @change="onChange"
    @blur="onBlur"
  ></v-text-field>
</template>

<script>
function tryParseFloat(str, defaultValue) {
  var retValue = defaultValue
  if (str !== null) {
    if (str.length > 0) {
      if (!isNaN(str)) {
        retValue = parseFloat(str)
      }
    }
  }
  return retValue
}
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: null,
    'error-messages': null,
    allowNegative: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: '$ ',
    },
    thousandsSeparator: {
      type: String,
      default: ',',
    },
    decimalSeparator: {
      type: String,
      default: '.',
    },
    rules: {
      type: Array,
    },
    languageCode: {
      type: String,
      default: 'en-US',
    },
  },
  data() {
    return {
      numberValue: this.value,
      model: this.value,
      isMasked: true,
      thousandsSeparatorRegex: new RegExp(`\\${this.thousandsSeparator}`, 'g'),
      decimalSeparatorRegex: new RegExp(`\\${this.decimalSeparator}`, 'g'),
    }
  },
  methods: {
    onFocus() {
      this.isMasked = false
      this.updateModel()
    },
    onBlur() {
      if (this.$listeners.blur) this.$listeners.blur()
      this.isMasked = true
      this.format()
    },
    onKeyUp() {
      this.updateNumberValue()
    },
    onChange() {
      if (this.$listeners.change) this.$listeners.change()
    },
    updateNumberValue() {
      let v = this.model
      let parsed
      v = v.replace(this.thousandsSeparatorRegex, '')
      if (this.decimalSeparator !== '.')
        v = v.replace(this.decimalSeparatorRegex, this.thousandsSeparator)
      const result = tryParseFloat(v)
      if (!result) parsed = 0
      else parsed = result
      if (!this.allowNegative && result < 0) parsed = 0
      this.numberValue = Math.round(parsed * 100) / 100
    },
    updateModel() {
      // console.devlog('update model')
      if (this.numberValue === null) return
      let v = this.numberValue.toString()
      v = v.replace(this.thousandsSeparatorRegex, this.decimalSeparator)
      this.model = v
    },
    format() {
      // console.devlog('format called')
      if (this.numberValue === null) {
        this.model = null
        return
      }
      let v = this.numberValue
      v = v.toLocaleString(this.languageCode)
      if (
        v.length !== 1 &&
        v.slice(v.indexOf(this.decimalSeparator) + 1).length === 1
      )
        v += '0'
      this.model = v
    },
  },
  watch: {
    numberValue(v) {
      // console.devlog('numberValue changed', v)
      this.$emit('input', v)
    },
    value(v) {
      // console.devlog('value changed', v)
      if (v) {
        this.numberValue = v
        if (!this.$refs.field.isFocused) {
          this.format()
        }
      }
    },
    model(v) {
      let re = /[^0-9-\.,]/gi
      this.$set(this, 'model', v.replace(re, ''))
    },
  },
  created() {
    this.format()
  },
}
</script>

<style lang="scss" scoped>
</style>